var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-section ag-offers-section",attrs:{"id":_vm.section.type+_vm.product.id}},_vm._l((_vm.section.offers),function(offer){return _c('offer',{key:offer.title,attrs:{"offer":offer},on:{"buy-offer-clicked":_vm.buy}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }